import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FollowTrainOverlayComponent } from './follow-train-overlay/follow-train-overlay.component';
import { FollowTrainService } from './follow-train.service';
import { FollowTrainButtonComponent } from './follow-train-button/follow-train-button.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

/**
 * FollowTrain feature
 * - toggles following train on map when FollowTrainButtonComponent is clicked
 * - centers the train on the map and as new location data is received the centering is updated.
 * - displays an overlay on the map when a train is being followed
 * - disables the map dragging when a train is being followed
 */
@NgModule({
  declarations: [FollowTrainOverlayComponent, FollowTrainButtonComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    TranslateModule,
    NgbTooltipModule
  ],
  providers: [FollowTrainService],
  exports: [FollowTrainOverlayComponent, FollowTrainButtonComponent]
})
export class FollowTrainModule { }
